import { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo";
import { Layout } from "../../../ui/layout";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { FilterInvoiceType, normativa, OptionType, StatoFatturaType, yearOptions } from "../../../utils";
import { GetByIdAnagraphic, resetGetByIdStatus } from "../../gestionePersonale/boxAnagrafica/slice";
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from "../../gestionePersonale/slice";
import { AssignmentsListReport } from "./listAssignments";
import { GetAllPersonaleContabile, resetGetAllPersonaleContabileFilters, setGetAllPersonaleContabileInspectorCode, setGetAllPersonaleContabileInvoice, setGetAllPersonaleContabileNorm, setGetAllPersonaleContabileStatus, setGetAllPersonaleContabileYear } from "./slice";

export function ReportPersonaleContabileView() {
    const dispatch = useAppDispatch()
    const personalManagementState = useAppSelector(state => state.personalManagement)
    const pmAnagraficaState = useAppSelector(state => state.PMAnagrafica)
    const PersonaleContabile = useAppSelector(state => state.PersonaleContabile)
    const [inspectors, setInspectors] = useState<OptionType[]>([])
    const [inspToSearch, setInspToSearch] = useState<string[]>([])

    useEffect(() => {
        dispatch(GetAllPersonalManagement({
            itemsPerPage: 0,
            page: 0,
            function: 'PERSONALE_ISPETTIVO',
            active: true
        }))
    }, [])

    useEffect(() => {
        dispatch(setGetAllPersonaleContabileInspectorCode('DABI'))
    }, [])

    useEffect(() => {
        if (personalManagementState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            personalManagementState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            const inspectorsIds = personalManagementState.getAllPersonalManagementResourcesResponse.data.map(pm => String(pm.anagraphicId))
            setInspToSearch(inspectorsIds)
        }
    }, [personalManagementState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (inspToSearch.length > 0) {
            dispatch(GetByIdAnagraphic(inspToSearch[0]))
        }
    }, [inspToSearch])


    useEffect(() => {
        if (pmAnagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            pmAnagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))

            const data = pmAnagraficaState.getByIdAnagraphicRequest
            const currInspectors = [...inspectors]
            currInspectors.push({
                value: data.identifierCode,
                label: `${data.name} ${data.surname} (${data.identifierCode})`
            } as OptionType)

            setInspectors(currInspectors)
            setInspToSearch(inspToSearch.slice(1))
        }
    }, [pmAnagraficaState.GetByIdAnagraphicStatus])

    if (PersonaleContabile.getAllPersonaleContabiletatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout
            menuItem={MenuItems.AMMINISTRAZIONE}
            breadcrumbItems={['Gestione Amministrazione', 'Gestione Personale - Contabile']}
            noPaddingLat
            headerLabel="Gestione Personale - Contabile"

        >
            <div className="flex flex-row gap-2 items-center px-6 pt-6">
                <MadfarmStaticSelect
                    noOptionsMessage="Nessun ispettore trovato"
                    defaultValue={PersonaleContabile.GetAllPersonaleContabileFilters.inspectorCode}
                    placeholder='Seleziona ispettore...'
                    options={inspectors}
                    value={PersonaleContabile.GetAllPersonaleContabileFilters.inspectorCode}
                    onChange={(value) => dispatch(setGetAllPersonaleContabileInspectorCode(value))}
                />
                <MadfarmStaticSelect
                    noOptionsMessage=""
                    placeholder={'Anno'}
                    value={PersonaleContabile.GetAllPersonaleContabileFilters.year}
                    options={yearOptions}
                    onChange={(value) => dispatch(setGetAllPersonaleContabileYear(value))}
                />

                <MadfarmStaticSelect
                    noOptionsMessage=""
                    placeholder={'Stato'}
                    value={PersonaleContabile.GetAllPersonaleContabileFilters.status}
                    options={StatoFatturaType}
                    onChange={(value) => dispatch(setGetAllPersonaleContabileStatus(value))}

                />

                <MadfarmStaticSelect
                    noOptionsMessage=""
                    key={PersonaleContabile.GetAllPersonaleContabileFilters.invoice || 'default'}
                    placeholder={'Fatture'}
                    value={PersonaleContabile.GetAllPersonaleContabileFilters.invoice}
                    options={FilterInvoiceType}
                    onChange={(value) => dispatch(setGetAllPersonaleContabileInvoice(value))}

                />
                <MadfarmStaticSelect
                    noOptionsMessage=""
                    placeholder={'Norma'}
                    options={normativa}
                    value={PersonaleContabile.GetAllPersonaleContabileFilters.norm}
                    onChange={(value) => {
                        dispatch(setGetAllPersonaleContabileNorm(value))
                    }}
                />
                <div className="w-[15%] flex flex-row items-center gap-2">
                    <ButtonComponent
                        size={"lg"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Pulisci"
                        color={"gray"}
                        onClick={() => dispatch(resetGetAllPersonaleContabileFilters())}
                    />
                    <ButtonComponent
                        disabled={PersonaleContabile.GetAllPersonaleContabileFilters.year === undefined || PersonaleContabile.GetAllPersonaleContabileFilters.inspectorCode === undefined}
                        size={"lg"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Cerca"
                        color={"orange"}
                        onClick={() => dispatch(GetAllPersonaleContabile(PersonaleContabile.GetAllPersonaleContabileFilters))}
                    />
                </div>
            </div>
            <AssignmentsListReport />
        </Layout >
    )
}